/** The Spanish catalogue for the touch pad — the wording only. Why each entry exists is argued in `en/touch.ts`. */
export default {
  no_fullscreen: 'este navegador no da pantalla completa',
  tilt_insecure: 'inclinación no disponible — esta página no es un contexto seguro; hace falta https',
  tilt_unsupported: 'inclinación no disponible — este navegador no expone el acelerómetro',
  tilt_on: 'inclinación activa — ±{deg}° sobre el arrastre',
  tilt_off: 'inclinación apagada',
  tilt_no_events: 'sin inclinación — el navegador no entrega `devicemotion` en esta página',
  tilt_no_accel: 'sin inclinación — llegan eventos pero este aparato no informa acelerómetro',
  tilt_refused: 'sin inclinación — {n} lecturas rechazadas: no miden gravedad (sostén el teléfono quieto)',
  tilt_denied: 'inclinación rechazada — el sistema no dio permiso de movimiento',
  tilt_no_https: 'sin HTTPS',
  tilt_no_sensor: 'sin sensor',
  tilt_no_permission: 'sin permiso',
  tilt_no_reading: 'sin lectura',
  no_lock: 'este navegador no puede fijar la orientación — gira el teléfono',
  not_locked: 'orientación no fijada — gira el teléfono',
  rotate: 'GIRA EL TELÉFONO',
  rotate_sub: 'ARENA se juega apaisado',
  fullscreen: 'pantalla completa',
  stand: 'DE PIE',
  kneel: 'AGACHAR',
  prone: 'A TIERRA',
  jump: 'SALTO',
  climb: 'TREPAR',
  third: 'TERCERA',
  stealth: 'SIGILO',
  hands: 'MANOS',
  kit: 'KIT',
  pack: 'MOCHILA',
  tilt: 'INCLINAR',
};
